import { Injectable } from "@angular/core";
import { ScreenBreakpoint } from "@ponder-shared/utils/screenBreakpoints";

/**
 * Handles calculating the size of preview items based on space available.
 */
@Injectable({ providedIn: "root" })
export class ItemSizeService {
    public width: number = 0;
    public height: number = 0;

    public readonly aspectRatioWidth = 5;
    public readonly aspectRatioHeight = 7;
    public readonly minMultiplier = 37;
    public readonly maxMultiplier = 55;
    public readonly minBreakpoint = ScreenBreakpoint.Small;
    public readonly maxBreakpoint = ScreenBreakpoint.XXLarge;

    public readonly minWidth = this.aspectRatioWidth * this.minMultiplier;          // 185
    public readonly minHeight = this.aspectRatioHeight * this.minMultiplier;        // 259

    public constructor() {
        this.recalculate();
    }

    public recalculate(): void {
        var f = Math.max(0.0, Math.min(1.0, (window.screen.width - this.minBreakpoint) / (this.maxBreakpoint - this.minBreakpoint)));
        var m = this.minMultiplier + (f * (this.maxMultiplier - this.minMultiplier));

        this.width = this.aspectRatioWidth * m;
        this.height = this.aspectRatioHeight * m;
    }
}